import { LIST } from '../constants/AvailableWidget';
import { AvailableWidget } from '../store/models';
import translate from '../locale/translate';
import { isBeta } from '../api/config';

import { IAvailableWidgetsAction } from '../interfaces/actions';

const initialState = [
    new AvailableWidget('Basic.title', 'Basic.TitleWidget', translate.gettext('TitleWidget'), {
        title: 'Titel',
        dateFormat: 'LL',
    }),
    new AvailableWidget('Basic.text', 'Basic.TextWidget', translate.gettext('TextWidget'), {
        size: 'small',
        text: '**Hello** *World*',
    }),
    new AvailableWidget('Basic.pagebreak', 'Basic.PageBreakWidget', translate.gettext('PageBreakWidget'), {
    }),
    // YSo, 16.08.2024: Deactivate only on the production system, remove widget from selection
    (isBeta
        ? new AvailableWidget('Inventory.ListInventory', 'Inventory.ListInventoryWidget', translate.gettext('ListInventoryWidget'), {
            displaySummary: true,
            displayCategorySYSTEM: true,
            displayCategoryBIOS: false,
            displayCategoryCPU: true,
            displayCategoryMEMORYDEVICE: true,
            displayCategoryDISK: false,
            displayCategoryDISPLAY: false,
            displayCategoryOS: true,
            displayCategoryOS_HOTFIX: false,
            displayCategoryLOCALINFO: false,
            displayCategoryPROGRAMS: false,
            displayCategoryNEVI: false,
        })
        : undefined
    ),
    new AvailableWidget('Alerts.monitoringOverview', 'Alerts.MonitoringOverviewWidget', translate.gettext('MonitoringOverviewWidget'), {
        displayContainers: true,
        displayAgents: true,
        shortMinutes: 60,
        longMinutes: 120,
    }),
    new AvailableWidget('Alerts.listAlertCount', 'Alerts.ListAlertCountWidget', translate.gettext('ListAlertCountWidget'), {
        displayChart: true,
        displayTable: true,
        displayAlertsTotal: true,
        displayAlertsNode: false,
        displayAlertsChildren: true,
    }),
    new AvailableWidget('Alerts.listAlertSummary', 'Alerts.ListAlertSummaryWidget', translate.gettext('ListAlertSummaryWidget'), {
        displayContainers: true,
        displayAgents: true,
        displayAlertDuration: true,
        displayDayDistribution: true,
        displayAlertPercentage: true,
    }),
    new AvailableWidget('Alerts.listAlerts', 'Alerts.ListAlertsWidget', translate.gettext('ListAlertsWidget'), {
        displayContainers: true,
        displayAgents: true,
        displayDate: true,
        displayLastDate: true,
        displayResolved: true,
        dateFormat: 'LLL',
    }),
    new AvailableWidget('listMeasurements', 'ListMeasurementsWidget', translate.gettext('ListMeasurementsWidget'), {
    }),
    new AvailableWidget('MAV.listSystems', 'MAV.ListSystemsWidget', translate.gettext('MAV.ListSystemsWidget'), {
        displayChart: true,
        displayTable: true,
    }),
    new AvailableWidget('MAV.listEvents', 'MAV.ListEventsWidget', translate.gettext('MAV.ListEventsWidget'), {
        displayTimestamp: true,
        displayMalwareCategory: true,
        displayMalwareName: true,
        displayModule: true,
    }),
    new AvailableWidget('MAV.listEventDays', 'MAV.ListEventDaysWidget', translate.gettext('MAV.ListEventDaysWidget'), {
        displaySystemName: true,
        displayMalwareCategory: true,
        displayMalwareName: true,
        displayModule: true,
    }),
    new AvailableWidget('PM.listSystems', 'PM.ListSystemsWidget', translate.gettext('PM.ListSystemsWidget'), {
        displayChart: true,
        displayTable: true,
        displayName: true,
        displayScanState: true,
        displayInstallState: true,
        displayLastScanTime: true,
    }),
    new AvailableWidget('PM.listJobs', 'PM.ListJobsWidget', translate.gettext('PM.ListJobsWidget'), {
        displaySystemsWithoutPM: true,
        displayState: true,
        displayCommand: true,
        displayMessage: true,
        displayPlannedStartTime: true,
        displayStartTime: true,
        displayEndTime: true,
    }),
    new AvailableWidget('PM.listSoftware', 'PM.ListSoftwareWidget', translate.gettext('PM.ListSoftwareWidget'), {
        displaySystemsWithoutSoftware: true,
        displayStatesWithoutSoftware: true,
    }),
    new AvailableWidget('SU.listSystems', 'SU.ListSystemsWidget', translate.gettext('SU.ListSystemsWidget'), {
        displayChart: true,
        displayTable: true,
        displayName: true,
        displayCategoryState: true,
        displayLastJobTime: true,
    }),
    new AvailableWidget('SU.listPatches', 'SU.ListPatchesWidget', translate.gettext('SU.ListPatchesWidget'), {
        displayEmptySections: true,
        displaySystemsWithoutPatches: true,
    }),
    // TBl: Deactivated 04.10.2023, remove widget from selection
    // new AvailableWidget('SU.listJobs', 'SU.ListJobsWidget', translate.gettext('SU.ListJobsWidget'), {
    //     displaySystemsWithoutJobs: false,
    //     displayState: true,
    //     displayType: true,
    //     displayMessage: true,
    //     displayStartTime: true,
    //     displayEndTime: true,
    //     displaySuccessfulJobs: true,
    //     displayFailedJobs: true,
    //     displayInProgressJobs: true,
    //     displayDownloadJobs: true,
    //     displayInstallJobs: true,
    //     displayScanJobs: true,
    // }),
].filter(x => x !== undefined);

initialState[0].maxPossibleUsage = 1;

export default function widgets(state = initialState, action: IAvailableWidgetsAction): AvailableWidget[] {
    switch (action.type) {
        case LIST: {
            return state;
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/availableWidgets.ts